module.exports = __webpack_public_path__ + "images/img-1jYDRdb.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/8.png
// module id = 2357
// module chunks = 0